import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowLeft,
  faArrowRight,
  faBars,
  faBarsStaggered,
  faBell,
  faBuilding,
  faCalculator,
  faCalendarDays,
  faChevronDown,
  faCircleNotch,
  faDoorOpen,
  faEuroSign,
  faDownload,
  faEye,
  faFileLines,
  faHandHoldingDollar,
  faHouse,
  faHouseChimneyUser,
  faHouseChimneyWindow,
  faPlus,
  faPen,
  faRightFromBracket,
  faArrowsRotate,
  faCheck,
  faCircleInfo,
  faTableCells,
  faUpload,
  faUsers,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

export function registerFontAwesomeIcons(library: FaIconLibrary): void {
  library.addIcons(
    faBars,
    faBarsStaggered,
    faBell,
    faBuilding,
    faCalculator,
    faCalendarDays,
    faChevronDown,
    faTrashCan,
    faPlus,
    faCircleNotch,
    faDoorOpen,
    faEuroSign,
    faDownload,
    faEye,
    faFileLines,
    faHandHoldingDollar,
    faHouse,
    faHouseChimneyUser,
    faHouseChimneyWindow,
    faArrowLeft,
    faArrowRight,
    faPen,
    faRightFromBracket,
    faArrowsRotate,
    faCheck,
    faCircleInfo,
    faTableCells,
    faUpload,
    faUsers,
    faXmark
  );
}
